/* tslint:disable */
/* eslint-disable */
/**
 * Commerce List App Service
 * This is to provide all the list related operations at data tier.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shikha.raghava@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AmwayUser } from './AmwayUser';
import { AmwayUserFromJSON, AmwayUserFromJSONTyped, AmwayUserToJSON } from './AmwayUser';
import type { ListEntryRequest } from './ListEntryRequest';
import { ListEntryRequestFromJSON, ListEntryRequestFromJSONTyped, ListEntryRequestToJSON } from './ListEntryRequest';

/**
 *
 * @export
 * @interface CreateListRequest
 */
export interface CreateListRequest {
  /**
   *
   * @type {AmwayUser}
   * @memberof CreateListRequest
   */
  amwayUser?: AmwayUser;
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  listType?: CreateListRequestListTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  partyId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateListRequest
   */
  isDisplayedOnShop?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  category?: string;
  /**
   *
   * @type {Array<ListEntryRequest>}
   * @memberof CreateListRequest
   */
  entries?: Array<ListEntryRequest>;
}

/**
 * @export
 */
export const CreateListRequestListTypeEnum = {
  Wishlist: 'WISHLIST',
  Shareable: 'SHAREABLE',
  Private: 'PRIVATE',
} as const;
export type CreateListRequestListTypeEnum =
  (typeof CreateListRequestListTypeEnum)[keyof typeof CreateListRequestListTypeEnum];

/**
 * Check if a given object implements the CreateListRequest interface.
 */
export function instanceOfCreateListRequest(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'name' in value;

  return isInstance;
}

export function CreateListRequestFromJSON(json: any): CreateListRequest {
  return CreateListRequestFromJSONTyped(json, false);
}

export function CreateListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateListRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amwayUser: !exists(json, 'amwayUser') ? undefined : AmwayUserFromJSON(json['amwayUser']),
    listType: !exists(json, 'listType') ? undefined : json['listType'],
    name: json['name'],
    partyId: !exists(json, 'partyId') ? undefined : json['partyId'],
    description: !exists(json, 'description') ? undefined : json['description'],
    isDisplayedOnShop: !exists(json, 'isDisplayedOnShop') ? undefined : json['isDisplayedOnShop'],
    category: !exists(json, 'category') ? undefined : json['category'],
    entries: !exists(json, 'entries') ? undefined : (json['entries'] as Array<any>).map(ListEntryRequestFromJSON),
  };
}

export function CreateListRequestToJSON(value?: CreateListRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amwayUser: AmwayUserToJSON(value.amwayUser),
    listType: value.listType,
    name: value.name,
    partyId: value.partyId,
    description: value.description,
    isDisplayedOnShop: value.isDisplayedOnShop,
    category: value.category,
    entries: value.entries === undefined ? undefined : (value.entries as Array<any>).map(ListEntryRequestToJSON),
  };
}
